import capitalizeString from '@/lib/helpers/capitalize-string';
import modelsStore from '@/lib/services/models-store';
import defineProperty from '@/lib/helpers/define-property';

const defineMethodsChildren = (instance, {
  selfName,
  nameSingular,
  namePlural,
  type,
}) => {
  const capitalizeNameSingular = capitalizeString(nameSingular);

  const nameIds = `${nameSingular}Ids`;
  defineProperty(instance, nameIds);
  instance[nameIds] = [];

  const adderName = `add${capitalizeNameSingular}`;
  const adderFunction = (modelToAdd, addStart = false) => {
    modelToAdd[selfName] = instance;

    if (addStart) {
      instance[nameIds] = [modelToAdd.id, ...instance[nameIds]];
    } else {
      instance[nameIds] = [...instance[nameIds], modelToAdd.id];
    }
  };

  Object.defineProperty(instance, adderName, {
    value: adderFunction,
  });

  const removerName = `remove${capitalizeNameSingular}`;
  const removerFunction = (modelToRemove) => {
    instance[nameIds] = instance[nameIds].filter(i => i !== modelToRemove.id);
  };
  Object.defineProperty(instance, removerName, {
    value: removerFunction,
  });

  const modelsGetter = () => instance[nameIds].map(
    modelId => modelsStore.modelForId(
      type,
      modelId,
    ),
  ).filter(model => typeof model.presence === 'undefined' || model.presence);
  Object.defineProperty(instance, namePlural, {
    get: () => modelsGetter(),
  });

  const modelsGetterAll = () => instance[nameIds].map(
    modelId => modelsStore.modelForId(
      type,
      modelId,
    ),
  );

  Object.defineProperty(instance, `all${capitalizeString(namePlural)}`, {
    get: () => modelsGetterAll(),
  });
};

export default defineMethodsChildren;
